import Vue from 'vue';
import Vuex from 'vuex';
import candles from './store/candles';
import intro from './store/intro';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    candles,
    intro,
  },
  state: {
    navbar: {
      transparent: true,
    },
  },
  mutations: {
    TOGGLE_ON_NAVBAR_TRANSPARENT(state) {
      state.navbar.transparent = true;
    },

    TOGGLE_OFF_NAVBAR_TRANSPARENT(state) {
      state.navbar.transparent = false;
    },
  },
  actions: {
  },
});
